const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <p>&copy; {currentYear} Andrew C. Kim. All rights reserved.</p>
        </footer>
    )
}

export default Footer;
